import type { GetPrebidUserIds, PrebidIdPartnerConfig } from "./IdPartners";

/**
 * @see https://docs.prebid.org/dev-docs/modules/userid-submodules/sharedid.html
 */
export const sharedIdPartner: GetPrebidUserIds = (
  config: PrebidIdPartnerConfig,
) => {
  if (!config.icPrebidSharedId) {
    return undefined;
  }

  return {
    name: "pubCommonId",
    storage: {
      type: "cookie",
      name: "_pubcid",
      expires: 365,
    },
  };
};
